/** Register / onboarding step constants */
export const ONBOARDING_STEPS = {
  ACCOUNT: 1,
  PHONE: 2,
  SUBSCRIBE: 3,
  COMPLIANCE: 4,
  LOCATION: 5,
  PHOTO: 6,
  CONTACTS: 7,
  CONFIRM: 8,
  GO_LIVE: 9,
  WELCOME: 10,
};

export const ONBOARDING_STEP_LABELS = [
  'Account',
  'Phone',
  'Subscribe',
  'Compliance',
  'Location',
  'Photo',
  'Contacts',
  'Messages',
  'Go live',
];

export function isOnboardingComplete(profile) {
  if (!profile) return false;
  // Pre-migration profiles won't have the column — treat as complete
  if (!Object.prototype.hasOwnProperty.call(profile, 'onboarding_completed_at')) {
    return true;
  }
  return Boolean(profile.onboarding_completed_at);
}

export function resolveOnboardingStep(profile) {
  if (!profile) return ONBOARDING_STEPS.ACCOUNT;
  if (profile.onboarding_completed_at) return ONBOARDING_STEPS.WELCOME;
  const step = Number(profile.onboarding_step);
  if (Number.isFinite(step) && step >= 1 && step <= ONBOARDING_STEPS.WELCOME) {
    return step;
  }
  return ONBOARDING_STEPS.PHONE;
}
